import React from 'react'; 
import { DeleteOutlined, EditOutlined, PlusOutlined, SearchOutlined} from '@ant-design/icons';
import { useState } from 'react';
import { useEffect } from 'react';
import { deleteDeliveryFee, getDeliveryFees, saveDeliveryFee } from '../../../networking/NetworkingBankNotes';
import AlertBox from '../../shared/AlertBox';
import LoadingBox from '../../shared/LoadingBox';
import { Button, Form, Input, InputNumber, Popconfirm, Select, Space, Table, Tooltip, Typography } from 'antd';
import Text from 'antd/lib/typography/Text';
import { formatToCurrencyWithScale } from '../../../helpers/FormatHelper';
import { useRef } from 'react';
import Highlighter from 'react-highlight-words';
import useLookUpTables from '../../maintenance/complaints/useLookUpTables';
const { Option } = Select;

const DeliveryFeeDetailsScreen = ({selectedDeliveryMethod}) => {
    
    const [fees, setFees] = useState([]);
    const lookUpTables = useLookUpTables('BNDelivery Regions');
    const [alertTitle, setAlertTitle] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [form] = Form.useForm();
    const [editingKey, setEditingKey] = useState(0);
    const [currentPage, setCurrentPage] = useState();

    const [filteringSomething, setFilteringSomething] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const [searchArray, setSearchArray] = useState({});
    const [currentID, setCurrentID] = useState(0);
    const [currentUpdateToken, setCurrentUpdateToken] = useState('');
    const searchInput = useRef();
     const defaultRowsSize = window.DEFAULT_ROWS_SIZE??20;


    const loadFees = async() =>{
        if(selectedDeliveryMethod && selectedDeliveryMethod.DeliveryFeeID > 0)
        {
            const filterObj = {
                "DeliveryFeeID": selectedDeliveryMethod.DeliveryFeeID
            }
            const responseSearch = await getDeliveryFees(filterObj);
            if(Number(responseSearch.httpStatusCode) === 200){
                setFees(responseSearch.deliveryFees);     
                if (responseSearch.deliveryFees) {
                    const feeList = responseSearch.deliveryFees.map((d) => ({...d, key: `fee-${d.ID}`}));
                    setFees(feeList);
                } else {
                    setFees([]);
                }                     
            }
            else{
                setFees([]);
            }
        }
    }
    
    useEffect(()=>{     
        loadFees();
    },[])

    const deleteFee = async (selectedDeliveryFee) =>{
        setLoading(true);
        const model = {
            DeliveryFeeID: selectedDeliveryFee.DeliveryFeeID,
		    DeliveryRegion : selectedDeliveryFee.DeliveryRegion,
            FromTier: selectedDeliveryFee.FromTier,
            ToTier: selectedDeliveryFee.ToTier
        }

        const response = await deleteDeliveryFee(model);
         if(Number(response.httpStatusCode) === 200){
            loadFees();
            setShowAlert(false);
         }
         else
         {
            console.log(response);
            setAlertTitle('Error');
            setAlertMessage(response.ErrorMessage);
            setShowAlert(true);
         }
         setLoading(false);
    }

    const saveFee = async(objDeliveryFee) =>{

        console.log(objDeliveryFee);
        const row = await form.validateFields();
        console.log(row);
        if(row)
        {
            const model = {
                DeliveryFeeID: selectedDeliveryMethod.DeliveryFeeID,
                DeliveryRegion : row.DeliveryRegion,
                FromTier: row.FromTier,
                ToTier: row.ToTier,
                DeliveryCost: row.DeliveryCost,
                UserID: localStorage.getItem('UserID')
            }

            setLoading(true);
            const response = await saveDeliveryFee(model);

            if(Number(response.httpStatusCode) === 200){
                loadFees();
            }
            else
            {
                console.log(response);
                setAlertTitle('Error');
                setAlertMessage(response.ErrorMessage);
                setShowAlert(true);
            }

            setLoading(false);
        }
    }

    
    const isEditing = (record) => record.ID === editingKey;

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
        setFilteringSomething(true);
    };

    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
        setFilteringSomething(false);
    };

    const settingSearchStateValues = (value, col) => {
        if (value != null) {
            setSearchText(value);
            setSearchedColumn(col);
            setSearchArray(...(searchArray[col] = value));
            setFilteringSomething(true);
        }
    };

    const getColumnSearchProps = (dataIndex) => ({
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={(node) => {
                            searchInput.current = node;
                        }}
                        placeholder={`Search ${dataIndex}`}
                        value={selectedKeys[0]}
                        onChange={(e) => {
                            setSelectedKeys(e.target.value ? [e.target.value] : []);
                        }}
                        onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        style={{
                            width: 188,
                            marginBottom: 8,
                            display: 'block'
                        }}
                    />
                    <Space>
                        <Button type="primary" onClick={() => handleSearch(selectedKeys, confirm, dataIndex)} icon={<SearchOutlined />} size="small" style={{ width: 90 }}>
                            Search
                        </Button>
                        <Button
                            onClick={() => {
                                handleReset(clearFilters);
                            }}
                            size="small"
                            style={{ width: 90 }}
                        >
                            Reset
                        </Button>
                        <Button
                            type="link"
                            size="small"
                            onClick={() => {
                                confirm({ closeDropdown: false });
                                settingSearchStateValues(selectedKeys[0], dataIndex);
                            }}
                        >
                            Filter
                        </Button>
                    </Space>
                </div>
            ),
            filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
            onFilter: (value, record) => (record[dataIndex] ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()) : ''),
            onFilterDropdownVisibleChange: (visible) => {
                if (visible) {
                    setTimeout(() => searchInput.current.select(), 100);
                }
            },
            render: (text) =>
                searchedColumn === dataIndex ? (
                    <Highlighter
                        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                        searchWords={[searchText]}
                        autoEscape
                        textToHighlight={text ? text.toString() : ''}
                    />
                ) : (
                    text
                )
        });

    const columns = [
        {
            title: 'Delivery Region',
            dataIndex: 'DeliveryRegion',
            width: '30%',
            editable: true,
            align: 'left',
            sorter: (a, b) => {
                return a['DeliveryRegion'].localeCompare(b['DeliveryRegion']);
            },
            sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('DeliveryRegion')
        },
        {
            title: 'From Tier',
            dataIndex: 'FromTier',
            width: '20%',
            editable: true,
            align: 'center',
            sorter: (a, b) => a['FromTier'] - b['FromTier'],
            sortDirections: ['descend', 'ascend'],
            render: (_, record) => <Text>{formatToCurrencyWithScale(record['FromTier'], 2)}</Text>
        },
        {
            title: 'To Tier',
            dataIndex: 'ToTier',
            width: '20%',
            editable: true,
            align: 'center',
            sorter: (a, b) => a['ToTier'] - b['ToTier'],
            sortDirections: ['descend', 'ascend'],
            render: (_, record) => <Text>{formatToCurrencyWithScale(record['ToTier'], 2)}</Text>
        },
        {
            title: 'Delivery Cost',
            dataIndex: 'DeliveryCost',
            width: '15%',
            editable: true,
            align: 'center',
            sorter: (a, b) => a['DeliveryCost'] - b['DeliveryCost'],
            sortDirections: ['descend', 'ascend'],
            render: (_, record) => <Text>{formatToCurrencyWithScale(record['DeliveryCost'], 2)}</Text>
        },
        {
            title: 'Actions',
            dataIndex: 'Actions',
            align: 'center',
            width: '15%',
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <a onClick={() => saveFee(record)} style={{ marginRight: 8 }}>
                            Save
                        </a>
                        <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
                            <a>Cancel</a>
                        </Popconfirm>
                    </span>
                ) : (
                    <div>
                        <Space size="middle">
                            <Tooltip title="Edit">
                                <Typography.Link disabled={editingKey !== 0 || (fees && fees.length > 0 && fees[0]['ID'] === 0) } onClick={() => edit(record)}>
                                    <EditOutlined />
                                </Typography.Link>
                            </Tooltip>
                            <Popconfirm title="Sure to delete?" onConfirm={() => deleteFee(record)}>
                                <Tooltip title="Delete">
                                    <a disabled={editingKey !== 0 || (fees && fees.length > 0 && fees[0]['ID'] === 0)}><DeleteOutlined/></a>
                                </Tooltip>
                            </Popconfirm>
                        </Space>
                    </div>
                );
            }
        }
    ];

    const edit = (record) => {
        if (fees && fees.length > 0 && fees[0]['ID'] === 0) {
            let auxFee= [...fees];
            auxFee.shift();
            setFees(auxFee);
        }

        form.setFieldsValue({
            UpdateToken: '',
            ...record
        });
        setEditingKey(record.ID);
        setCurrentID(record.ID);
        setCurrentUpdateToken(record.UpdateToken);
    };

    const cancel = (page) => {
        setEditingKey(0);
        if (typeof page === 'number') {
            setCurrentPage(page);
        }

        if (fees && fees.length > 0 && fees[0]['ID'] === 0) {
            let auxFee = [...fees];
            auxFee.shift();
            setFees(auxFee);
        }
    };

    const isRangeValidUpdate = (ID, DeliveryRegion, fromObj, toObj) => {

        const feesByDeliveryRegion = fees.filter(f => f.DeliveryRegion === DeliveryRegion);

        return !feesByDeliveryRegion.some(item => {
            if (item.ID === ID) return false;

            const from = item.FromTier;
            const to = item.ToTier;

            return fromObj <= to && toObj >= from;
        });
    }

    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }

        let type = '';

        switch (col.dataIndex) {
            case 'FromTier':
            case 'ToTier':
            case 'DeliveryCost':{
                type = 'number';
                break;
            }
            case 'DeliveryRegion': {
                type = 'select';
                break;
            }
            default: {
                type = 'text';
                break;
            }
        }

        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: type,
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record)
            })
        };
    });

    const EditableCell = ({ editing, dataIndex, title, inputType, record, index, children, ...restProps }) => {
        let inputNode = null;
        switch (inputType) {
            case 'number': {
                inputNode = <InputNumber min={0} style={{ width: '100%', textAlignLast: 'center' }} />;
                break;
            }
            case 'select': {
                switch (title) {
                    default:
                    case 'DeliveryRegion': {
                        inputNode = (
                            <Select
                                showSearch
                                style={{ width: '100%' }}
                                placeholder="Select a Region"
                                optionFilterProp="children"
                                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            >
                                {lookUpTables.BNDeliveryRegions.map((region) => (
                                    <Option
                                        key={`regions-options-${region.value}`}
                                        value={region.value}>{region.name}
                                    </Option>
                                ))}
                            </Select>);
                        break;
                    }
                }
                break;
            }
            default: {
                inputNode = <Input style={{ textAlign: 'center' }} />;
                break;
            }
        }

        let styleEdit = { margin: 0 };

        if ((record !== undefined && record.isNew !== undefined && record.isNew === true) || editing) {
            styleEdit = {
                paddingBottom: 10,
                paddingTop: 10,
                margin: 0
            };
        }

        const getCustomRules = (columnDataIndex) => {
            switch (columnDataIndex) {                
                case 'FromTier': {
                    return [{
                        min: 0,
                        type: 'number',
                        mesage: 'Please Input a valid number!'
                    },
                    ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (getFieldValue('ToTier') >= value) {
                                return Promise.resolve();
                              }
                              return Promise.reject(new Error('From Tier should be less than or equal to To Tier!'));
                            },
                          }),
                    ({ getFieldValue }) => ({
                            validator(_, value) {
                             if(isRangeValidUpdate(getFieldValue('ID'), getFieldValue('DeliveryRegion'), value, getFieldValue('ToTier'))){
                                return Promise.resolve();
                              }
                              return Promise.reject(new Error('Values overlap'));
                            },
                          }),
                ]
                }
                case 'ToTier': {
                    return [
                        {
                            min: 0,
                            type: 'number',
                            mesage: 'Please Input a valid number!'
                        },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (getFieldValue('FromTier') <= value) {
                                return Promise.resolve();
                              }
                              return Promise.reject(new Error('From Tier should be less than or equal to To Tier!'));
                            },
                          }),                        
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                             if(isRangeValidUpdate(getFieldValue('ID'), getFieldValue('DeliveryRegion'), getFieldValue('FromTier'), value)){
                                return Promise.resolve();
                              }
                              return Promise.reject(new Error('Values overlap'));
                            },
                          }),
                    ];
                }
                case 'DeliveryCost': {
                    return [{
                        min: 0,
                        type: 'number',
                        mesage: 'Please Input a valid number!'
                    }]
                }
                case 'DeliveryRegion': {
                    return [
                    () => ({
                            validator(_, value) {
                              if (!value.toLowerCase().includes('select ')) {
                                return Promise.resolve();
                              }
                              return Promise.reject(new Error('Please select a Delivery Region'));
                            },
                          }),
                    ]
                }
                default: return [
                    {
                        required: true,
                        message: `Please Input a ${title}!`
                    }
                ];
            }
        }
        const rules = getCustomRules(dataIndex);

        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item name={dataIndex} style={styleEdit} rules={rules}>
                        {inputNode}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    };

    const addNewFee = () => {
        let actual = [...fees];
        if (actual[0] != null && actual[0]['ID'] === 0) {
            return;
        } else {
            actual.unshift({
                'key': 'fee-new',
                'ID': 0,
                'DeliveryFeeID': selectedDeliveryMethod.DeliveryFeeID,
                'DeliveryRegion': '',
                'FromTier': 0,
                'ToTier': 0,
                'DeliveryCost': 0,
                UpdateToken: '',
                isNew: true
            });
            setFees(actual);
            setCurrentPage(1);
            form.setFieldsValue({
                'DeliveryRegion': '',
                'FromTier': 0,
                'ToTier': 0,
                'DeliveryCost': 0,
                ...actual
            });
            setCurrentUpdateToken('');
            setCurrentID('');
        }
    };

    function itemRender(current, type, originalElement) {
        if (type === 'prev') {
            return <a>Previous</a>;
        }
        if (type === 'next') {
            return <a>Next</a>;
        }
        return originalElement;
    }

    return(
        <> 
            <Form form={form} component={false}>
             <Table
                components={{ body: { cell: EditableCell } }}
                dataSource={fees}
                columns={mergedColumns}
                size='small'
                pagination={{
                    onChange: cancel,
                    showQuickJumper: true,
                    itemRender: itemRender,
                    current: currentPage,
                    defaultCurrent: 1,
                    size: 'default',
                    defaultPageSize: defaultRowsSize
                }}
                footer={() => (
                    <Button
                        type="dashed"
                        onClick={addNewFee}
                        block
                        icon={<PlusOutlined />}
                        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                        disabled={editingKey !== 0 || filteringSomething || (fees && fees.length > 0 && fees[0]['ID'] === 0)}
                    >
                        Add a Fee
                    </Button>
                )}/>
            </Form>
            <AlertBox open={showAlert} onClose={()=>setShowAlert(false)} title={alertTitle} message={alertMessage} type="Ok" okClick={()=>setShowAlert(false)}/>
            <LoadingBox loading={loading}/>
        </>
    );
    
}

export default DeliveryFeeDetailsScreen